const conversionFactors = {
  'Volts': 1,
  'Microvolts': 1e-6,
  'Millivolts': 1e-3,
  'Kilovolts': 1e3,
  'Megavolts': 1e6,
  'Gigavolts': 1e9,
  'Statvolts': 299.792458,
  'Abvolts': 1e-8,
  'EMU of electric potential': 1e-8,
  'ESU of electric potential': 299.792458,
  'Webers per meter': 1
};

export const convertVoltage = (value, fromUnit, toUnit) => {
  const voltsValue = value * conversionFactors[fromUnit];
  const result = voltsValue / conversionFactors[toUnit];
  
  return Number(result.toPrecision(10));
};
